export function isEmpty(val){
  return (val==='' || val ==='null' || val === undefined || val === null)?'d-none':'';
}

export const markdownToHtml = (markdown) => {
  // Convertir encabezados
  let html = markdown.replace(/^###### (.*$)/gim, '<h6>$1</h6>');
  html = html.replace(/^##### (.*$)/gim, '<h5>$1</h5>');
  html = html.replace(/^#### (.*$)/gim, '<h4>$1</h4>');
  html = html.replace(/^### (.*$)/gim, '<h3>$1</h3>');
  html = html.replace(/^## (.*$)/gim, '<h2>$1</h2>');
  html = html.replace(/^# (.*$)/gim, '<h1>$1</h1>');  
  html = html.replace(/^\* (.*$)/gim, '<ul><li>$1</li></ul>');  
  html = html.replace(/^\d+\. (.*$)/gim, '<ol><li>$1</li></ol>');  
  html = html.replace(/\*\*(.*)\*\*/gim, '<strong>$1</strong>');  
  html = html.replace(/\*(.*)\*/gim, '<em>$1</em>');  
  html = html.replace(/\[(.*?)\]\((.*?)\)/gim, '<a href="$2" target="_blank" class="link-boot-m">$1</a>');
  html = html.replace(/!\[(.*?)\]\((.*?)\)/gim, '<img src="$2" alt="$1" class="img-boot-m">');
  html = html.replace(/\n/gim, '<br/>');  
  return html;
};

export const convertTextToHtmlWithLinks = (text) => {  
  let result = text;
  /*
  const urlRegex = /https?:\/\/[^\s]+/g;

  const parts = text.split(urlRegex);
  const links = text.match(urlRegex);

  if (!links) {
    return text;
  }

  
  parts.forEach((part, index) => {
    result += part; 
    if (links[index]) {      
      result += `<a href="${links[index]}" target="_blank" rel="noopener noreferrer">${links[index]}</a>`;
    }
  });
  */

  return result;
};


export const navigateTo=()=>{
  let url = process.env.REACT_APP_SUBSCRIPTION_URL;
  window.open(url, '_blank');
}